import {BackendApi} from "../api.ts";
import {extractApiErrorMessage} from "../../lib/apiErrors.ts";
import {Customer, CustomerDraft} from "./Customer.ts";

export async function listCustomers(api: BackendApi): Promise<Customer[]> {
    try {
        const body = await api.Me__business__getCustomers({})
        return body.customers
    } catch (error) {
        throw asCustomerError(error, 'Klanten ophalen mislukt')
    }
}

export async function createCustomer(api: BackendApi, draft: CustomerDraft): Promise<Customer> {
    try {
        return await api.Me__business__createCustomer(draft)
    } catch (error) {
        throw asCustomerError(error, 'Klant aanmaken mislukt')
    }
}

export async function changeCustomer(
    api: BackendApi,
    customerId: string,
    draft: CustomerDraft,
): Promise<Customer> {
    try {
        return await api.Me__business__changeCustomer({...draft, id: customerId})
    } catch (error) {
        throw asCustomerError(error, 'Klant bijwerken mislukt')
    }
}

export async function archiveCustomer(api: BackendApi, customerId: string): Promise<void> {
    try {
        await api.Me__business__archiveCustomer({id: customerId})
    } catch (error) {
        throw asCustomerError(error, 'Klant archiveren mislukt')
    }
}

function asCustomerError(error: unknown, fallback: string): unknown {
    if (!(error instanceof Error) || error.name !== 'Non200ResponseError') return error

    const detail = extractApiErrorMessage(error)
    if (detail) return new Error(detail)

    return new Error(error.message ? `${fallback} (${error.message})` : fallback)
}
